export default "__VITE_ASSET__DUFZ75X2__"